import { render } from "./selectPay.vue?vue&type=template&id=7f1a3d14&scoped=true"
import script from "./selectPay.vue?vue&type=script&lang=js"
export * from "./selectPay.vue?vue&type=script&lang=js"

import "./selectPay.vue?vue&type=style&index=0&id=7f1a3d14&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1a3d14"]])

export default __exports__